import React from 'react';
import { HelpContent } from '@kineticdata/ui';

export const SpaceHelp = () => (
  <HelpContent>
    <h6>General</h6>
    <p>Name, slug, and bundle base directory.</p>

    <h6>Users</h6>
    <p>Manage users for a Space.</p>

    <h6>Infrastructure</h6>
    <p>
      Manage Platform Infrastructure configurations such as the Task instance
      information, Task Database, or Authentication Secret
    </p>

    <h6>Task Engine</h6>
    <p>View the status of the Task engine and start or stop it if necessary.</p>
  </HelpContent>
);
